import React, { useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@material-ui/core";
import { useStyles } from "./styles";
import NewCommonButton from "../CommonButton/NewCommonButton";
import { PrintSharp } from "@material-ui/icons";
import moment from "moment";

interface Props {
  columns: any;
  rows?: any;
  height?: number;
  loader?: boolean;
  defaultPerPageRecord?: number;
  deletedRow?: boolean;
  hideFooter?: boolean;
  handlePrint?: any;
}

const CommonMaterialGrid2 = ({
  columns,
  rows,
  height,
  loader = false,
  deletedRow = false,
  hideFooter = true,
  handlePrint,
}: Props) => {
  const classes = useStyles();
  const emptyMessage = useMemo(() => {
    return <div className={classes.label}>No results found</div>;
  }, []);

  const muiTableBodyCellProps = (row: any) => {
    return {
      sx: deletedRow && row.row.original.isDeleted ? { color: "red" } : {},
    };
  };

  const muiTableHeadCellProps = (row: any) => {
    const { inventoryTransactions } = row.row.original;
    const { vehicleNumber } = row.row.original;

    return (
      <table className={classes.table}>
        <tr>
          <th className={classes.tableHead}>Serial #</th>
          <th className={classes.tableHead}>Vehicle #</th>
          <th className={classes.tableHead}>Supplier Name</th>
          <th className={classes.tableHead}>Date & Time</th>
          <th className={classes.tableHead}>Transcation Type</th>
          <th className={classes.tableHead}>Quantity</th>
          <th className={classes.tableHead}>Accumulative</th>
          <th className={classes.tableHead}>Action</th>
        </tr>
        {inventoryTransactions &&
          inventoryTransactions?.map((item: any, index: number) => (
            <tr key={index}>
              <td className={classes.tableHead}>{++index} </td>
              <td className={classes.tableHead}>
                {item?.regNumber ? item?.regNumber : vehicleNumber || "-"}
              </td>
              <td className={classes.tableHead}>{item?.supplierName} </td>
              <td className={classes.tableHead}>
                {item.transactionDate
                  ? moment(item.transactionDate).format("DD-MM-YYYY hh:mm:ss A")
                  : ""}
              </td>
              <td className={classes.tableHead}>
                {item.transactionType === 1 ? "Receive" : "Issue" || " "}
              </td>
              <td className={classes.tableHead}>
                {item.quantity || 0}{" "}
                {item.weightunit
                  ? item.weightunit == "Cubic meter"
                    ? "m³"
                    : item.weightunit
                  : "Kg"}
              </td>
              <td className={classes.tableHead}>
                {item.totalItemWeight || 0}{" "}
                {item.weightunit
                  ? item.weightunit == "Cubic meter"
                    ? "m³"
                    : item.weightunit
                  : "Kg"}
              </td>
              <td className={classes.tableHead}>
                <NewCommonButton onClick={() => handlePrint(item)} icon={<PrintSharp />} isGreen>
                  Print
                </NewCommonButton>
              </td>
            </tr>
          ))}
      </table>
    );
  };

  return (
    <div className={classes.root}>
      <Box style={{ width: "100%", height: "100%" }}>
        <MaterialReactTable
          columns={columns}
          data={rows}
          enableColumnFilterModes
          enableColumnOrdering={true}
          enableGrouping
          enablePinning
          enableColumnResizing
          enableRowSelection={false}
          initialState={{ density: "compact" }}
          enableStickyHeader
          enableFullScreenToggle={false}
          enablePagination={hideFooter}
          // initialState={{ showColumnFilters: true }}
          state={{ isLoading: loader }}
          muiTableContainerProps={{
            sx: { height: height },
          }}
          renderEmptyRowsFallback={() => emptyMessage}
          muiTableBodyCellProps={muiTableBodyCellProps}
          muiTableHeadCellProps={{
            sx: () => ({
              background: "black",
              // borderRight: "white",
              color: "white",
            }),
          }}
          renderDetailPanel={muiTableHeadCellProps}
        />
      </Box>
    </div>
  );
};

export default CommonMaterialGrid2;
